"use client";
import { loginUser } from "@/api/user/loginUser";
import { Header } from "@/components";
import { LoginForm } from "@/components/login-flow";
import Footer from "@/components/officer-dashboard/officer-reset-password/Footer.js";
import useToast from "@/hooks/useToast";
import { useMutation } from "@tanstack/react-query";
import { useParams, useRouter } from "next/navigation";
import { useState } from "react";

const Login = () => {
  const router = useRouter();
  const [loginError, setLoginError] = useState("");
  const role = "user"
  const { locale } = useParams() ?? {};
  const { showToast } = useToast();

  // Set up the mutation
  const loginMutation = useMutation({
    mutationFn: loginUser,
    onSuccess: (data) => {
      console.log("data", data);
      // Store auth token
      localStorage.setItem("token", data.access_token);
      document.cookie = `token=${data.access_token}; path=/; max-age=86400`;

      // Store user data if available
      if (data.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
      }

      console.log(data.role);

      showToast({
        type: "success",
        message: "Login successful!",
      });

      // Redirect based on role
      if (data.role) {
        console.log("If part", data.role);
        if (data.role === "user") {
          router.push(`/${locale}`);
        } else if (data.role === "admin") {
          router.push(`/${locale}/admin`);
        } else {
          router.push(`/${locale}/officer-dashboard?officerType=${data.role}`);  
        }
      } else {
        // Default redirect
        console.log("Else part");
      }
    },
    onError: (error) => {
      const errorMessage = error?.message || "Login failed!";
      
      showToast({
        type: "error",
        message: errorMessage,
      });
      
      setLoginError(errorMessage);
    },
  });

  const handleLogin = (formData) => {
    loginMutation.mutate(formData);
  };

  return (
    <div className="bg-gray-100 flex flex-col gap-6">
      <Header />

      <LoginForm
        role={role}
        onSubmit={handleLogin}
        isLoading={loginMutation.isPending}
        error={loginError}
      />

      <Footer />

      <img
        src="/officer-login.png"
        className="w-full h-32 object-cover mt-24 opacity-10"
      />
    </div>
  );
};

export default Login;